/*  
                         __    _                                   
                    _wr""        "-q__                             
                 _dP                 9m_     
               _#P                     9#_                         
              d#@                       9#m                        
             d##                         ###                       
            J###                         ###L                      
            {###K                       J###K                      
            /####K      ___aaa___      J####F                      
        __gmM######_  w#P""   ""9#m  _d#####Mmw__                  
     _g##############mZ_         __g##############m_               
   _d####M@PPPP@@M#######Mmp gm#########@@PPP9@M####m_             
  a###""          ,Z"#####@" '######"\g          ""M##m            
 J#@"             0L  "*##     ##@"  J#              *#K           
 #"               `#    "_gmwgm_~    dF               `#_          
7F                 "#_   /#####F   _dK                 JE          
/                    *m__ ##### __g@"                   F          
                       "PJ#####LP"                                 
 `                       0######_                      '           
                       _0########_                                   
     .               _d#####^#####m__              ,              
      "*w_________am#####P"   ~9#####mw_________w*"                  
          ""9@#####@M""           ""P@#####@M""     
CAUTION BIOHAZARD!!!           
*/
import React from 'react'
import { omit, flatten, isEqual, compact, debounce } from 'lodash'
import Ajax from 'superagent'
import { withScriptjs, withGoogleMap, GoogleMap, Marker, DirectionsRenderer, Polyline, OverlayView } from "react-google-maps"

import { getText, getTextWithTokens } from '../lib/text.js'
import {fetchGeolocation} from '../lib/AppTools'

function isNumber(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
}

function findNextHotel(array, n) {
  const item = array[n]
  if (item.type == "expense" && ((item.expense && item.expense.type == "hotel") || item.ref))
    return item
  else return findNextHotel(array, n + 1)
}

const travelModes = {
  PUBLIC_TPT: "TRANSIT",
  TRANSIT: "TRANSIT",
  WALKING: "WALKING",
  DRIVE: "DRIVING",
  CABIFY: "DRIVING",
  GUIDE: "DRIVING",
  OTHER: "DRIVING",
}
const travelModesTrans = {
  PUBLIC_TPT: "en transporte público",
  TRANSIT: "en transporte público",
  WALKING: "andando",
  DRIVE: "conduciendo",
  CABIFY: "en cabify",
  GUIDE: "en coche con guia",
  OTHER: "(con otro)",
}

const transportTrad = {
  train: "RAIL"
}

const markColor = {
  activity : "red",
  expense : "blue",
  city : "green"
}

const getPixelPositionOffset = (width, height) => ({
  x: -(width / 1.9),
  y: -(height / 2),
})

const GmapsCubicBezier = function (lat1, long1, lat2, long2, lat3, long3, lat4, long4, resolution, map, distance, order) {

  let mark
  const points = [];
  const path = [];
  const lineSymbol = {
    path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
  }

  for (let it = 0; it <= 1; it += resolution) {
    points.push(this.getBezier({ x: lat1, y: long1 }, { x: lat2, y: long2 }, { x: lat3, y: long3 }, { x: lat4, y: long4 }, it));
  }
  for (let i = 0; i < points.length - 1; i++) {
    if (i == points.length / 2) {
      mark = <Marker position={{ lat: points[i].x, lng: points[i].y }} icon={`https://raw.githubusercontent.com/Concept211/Google-Maps-Markers/master/images/marker_red${order}.png`} />
    }
    const Line = <Polyline
      path={[new google.maps.LatLng(points[i].x, points[i].y), new google.maps.LatLng(points[i + 1].x, points[i + 1].y)]}
      options={i % 6 == 0 ? {
        strokeOpacity: 0.7,
        strokeWeight: (distance / 5) + 1.5 > 3 ? 3 : (distance / 5) + 1.5,
        icons: [{
          icon: lineSymbol,
          offset: '100%',
        }],
      } : { strokeOpacity: 0.7, strokeWeight: (distance / 5) + 1.5 > 3 ? 3 : (distance / 5) + 1.5 }}
    />
    path.push(Line)
  }
  return { path, mark }
};

GmapsCubicBezier.prototype = {

  B1: function (t) { return t * t * t; },
  B2: function (t) { return 3 * t * t * (1 - t); },
  B3: function (t) { return 3 * t * (1 - t) * (1 - t); },
  B4: function (t) { return (1 - t) * (1 - t) * (1 - t); },
  getBezier: function (C1, C2, C3, C4, percent) {
    const pos = {}
    pos.x = C1.x * this.B1(percent) + C2.x * this.B2(percent) + C3.x * this.B3(percent) + C4.x * this.B4(percent)
    pos.y = C1.y * this.B1(percent) + C2.y * this.B2(percent) + C3.y * this.B3(percent) + C4.y * this.B4(percent)
    return pos
  }
}

function getCoord(citiesPath, i) {
  const latEnd = citiesPath[i].lat
  const latStart = citiesPath[i + 1].lat
  const longEnd = citiesPath[i].lng
  const longStart = citiesPath[i + 1].lng
  return { latEnd, latStart, longEnd, longStart }
}

function getErrorMsg(status, ruta, u) {
  if (status == "NOT_FOUND") return getText("No se pudo geocodificar al menos a una de las ubicaciones especificadas.")
  else if (status == "ZERO_RESULTS") return getTextWithTokens(`No fue posible hallar una ruta $$ entre $$ y $$. Pruebe a cambiar el modo de transporte.`, [getText(travelModesTrans[ruta[u + 1].mode]), ruta[u].name, ruta[u + 1].name])
  else if (status == "OVER_QUERY_LIMIT") return getText("¡Vas demasiado rápido! Por el ratón de nuevo sobre el día.")
  else return "Error"
}

class Map extends React.PureComponent {

  constructor(props) {
    super(props)
    this.state = { [props.routeId]: { lastDayHovered: 0 } }
    this.debounceupdateMap = debounce((nextProps) => {
      this.getRoute(nextProps)
    }, 1000, {trailing : true})
  }

  
  componentDidMount() {
    this.getCities(this.props)
  }

  componentWillReceiveProps(nextProps) {

    this.setState({ [nextProps.routeId]: { ...this.state[nextProps.routeId], lastDayHovered: nextProps.day || 0 } })

  /*if (nextProps.day != 0 && (this.props.day != nextProps.day || !isEqual(nextProps.route, this.state.rawRoute)))
      this.getRoute(nextProps)
    else if (nextProps.day == 0) {
      this.getCities(nextProps)
    }*/

    if (nextProps.day != 0) {
      if (this.props.day != nextProps.day) {
        this.debounceupdateMap.cancel()
        this.getRoute(nextProps)
      }
      else if (!isEqual(nextProps.route, this.state.rawRoute)) {
        this.debounceupdateMap(nextProps)
      } 
    }
    else this.getCities(nextProps)
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState[nextProps.routeId][`break${nextProps.day}`]) {
      nextProps.googleMapError(nextState[nextProps.routeId].errormsg)
    }
    else {
      nextProps.googleMapError("")
    }
    if (nextState[nextProps.routeId][`needLegend${nextProps.day}`]) {
      nextProps.setLegend(true)
    }
    else {
      nextProps.setLegend(false)
    }

  }

  getRoute(props) {
    
    this.setState({ [props.routeId]: { ...this.state[props.routeId], [`break${props.day}`]: false } })
    props.loadingMap(false)
    props.setLegend(false)

    this.setState({ rawRoute: props.route})
    
    this.calculateRoute(props)
  }

  getCities(props) {
    const citiesOrder = []
    let path = []
    const marks = []
    const citiesBound = new google.maps.LatLngBounds()

    const citiesRoute = props.route.filter((i, n) => i.type == "city" && n!=props.route.length - 1)
    if (!this.state[props.routeId] || !isEqual(this.state[props.routeId].route0, citiesRoute)) { //We check if we already calculated the trip route and if its the same, so we dont make unnecesary requests
      Promise.all(citiesRoute.map(c =>
        new Promise((resolve, reject) => {
          const city = props.Cities[c.city]
          citiesOrder.push(city)
          if (city.preciseLocation && city.preciseLocation.latitude && city.preciseLocation.longitude) {
            const location = {lat : city.preciseLocation.latitude, lng : city.preciseLocation.longitude}
            citiesBound.extend(location)
            resolve(location)
          } 
          else {
            fetchGeolocation(`${city.name}, ${city.country}`).then(geolocation => {
              citiesBound.extend(geolocation.geometry.location)
              resolve({
                lat: geolocation.geometry.location.lat,
                lng: geolocation.geometry.location.lng,
              })
            }).catch((e) => {
              console.error(e)
              reject({isActivity : false, name : city.name})
            })
          }
        })
      ))
        .then(citiesPath => {
          for (let i = 0; i < citiesPath.length - 1; i++) {
            const a = citiesPath[i].lat - citiesPath[i + 1].lat
            const b = citiesPath[i].lng - citiesPath[i + 1].lng
            const distance = Math.sqrt((a * a) + (b * b))
            const delta = distance / 30
            if (i == 0) { //We put a green mark on the first city
              marks.push(<Marker position={citiesPath[i]} icon={`../../static/img/marks/marker_green.png`} />)
            }
            if (i == citiesPath.length - 2) { //We put a blue mark on the last city
              marks.push(<Marker position={citiesPath[i + 1]} icon={`../../static/img/marks/marker_blue.png`} />)
            }
            if (i > 0 && i < citiesPath.length && citiesOrder[i - 1] == citiesOrder[i + 1]) { //Here we calculate the bezier line of the departure to a city
              const coord = getCoord(citiesPath, i)
              const bezier = new GmapsCubicBezier(coord.latStart, coord.longStart, coord.latStart + delta, coord.longStart + delta * 2, coord.latEnd + delta, coord.longEnd + delta * 2, coord.latEnd, coord.longEnd, 0.05, this.map, distance, i + 1)
              path = path.concat(bezier.path)
              marks.push(bezier.mark)
            } else if (i < citiesPath.length && citiesOrder[i] == citiesOrder[i + 2]) { //Here we calculate the bezier line of the come back from a city
              const coord = getCoord(citiesPath, i)
              const bezier = new GmapsCubicBezier(coord.latStart, coord.longStart, coord.latStart - delta, coord.longStart - delta * 2, coord.latEnd - delta, coord.longEnd - delta * 2, coord.latEnd, coord.longEnd, 0.05, this.map, distance, i + 1)
              path = path.concat(bezier.path)
              marks.push(bezier.mark)
            } else {
              marks.push(<Marker position={{ lat: (citiesPath[i].lat + citiesPath[i + 1].lat) / 2, lng: (citiesPath[i].lng + citiesPath[i + 1].lng) / 2 }} icon={`../../static/img/marks/red${i + 1}.png`} />)
              path.push(
                <Polyline
                  path={[citiesPath[i], citiesPath[i + 1]]}
                  options={{
                    strokeOpacity: 0.7,
                    strokeWeight: (distance / 5) + 1.5 > 3 ? 3 : (distance / 5) + 1.5,
                    icons: [{
                      icon: {
                        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                      },
                      offset: '30%'
                    },
                    {
                      icon: {
                        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
                      },
                      offset: '80%'
                    }]
                  }}
                />
              )
            }
          }
          this.setState({ [props.routeId]: { ...this.state[props.routeId], bound0: citiesBound, day0: path, marks0: marks, route0: citiesRoute, break0: false } })
        })
        .catch((e) => {
          this.setState({ [props.routeId]: { ...this.state[props.routeId], break0: true, route0: "", errormsg: `Error al cargar ${e.name}` } })
        }
        )
    }
  }

  addCoordsRoute(props, dayRoute) {
    return new Promise((resolve, reject) => {
      if (
        isEqual(dayRoute, this.state[props.routeId][`dayRoute${props.day}`]) 
        && this.state[props.routeId][`geoLocatedRoute${props.day}`]
      ) { 
        return resolve(this.state[props.routeId][`geoLocatedRoute${props.day}`])
      }
      else {
        this.setState({ 
          [props.routeId]: { 
            ...this.state[props.routeId], 
            [`needLegend${props.day}`]: false, 
          }
        })
        Promise.all(dayRoute.map((x, i, array) => {
          return new Promise((mapresolve, mapreject) => {
            // if (x.type == "city" && (i == 0 || i == array.length - 1)) mapresolve()
            if (!x.preciseLocation || !x.preciseLocation.latitude || !x.preciseLocation.longitude) {
              Ajax
                .get(`/private/getmapcoords`)
                .query({address : `${x.name}, ${x.city}`})
                .then(res => {
                  const geolocation  = res.body
                  if (x.type == "activity") {
                    this.setState({ 
                      [props.routeId]: { 
                        ...this.state[props.routeId], 
                        [`needLegend${props.day}`]: true, 
                      }
                    })
                  }
                  mapresolve({
                    lat: geolocation.geometry.location.lat,
                    lng: geolocation.geometry.location.lng,
                    mode: (x.recommendedTransportation != "airplane" && x.recommendedTransportation) || "DRIVE",
                    color: x.type == "activity" ? "orange" : markColor[x.type],
                    transport: x.transportType != 'airplane' ? x.transportType : "",
                    name: x.type == "activity" ? props.Activities[x.id].name : x.name
                  })
                }).catch((e) => {
                  console.error(e)
                  mapreject({isActivity : x.type == "activity", name : x.name, id : x.type == "activity" ? props.Activities[x.id]._id : ""})
                })
            }
            else {
              mapresolve({
                lat: x.preciseLocation.latitude,
                lng: x.preciseLocation.longitude,
                mode: (x.recommendedTransportation != "airplane" && x.recommendedTransportation) || "DRIVE",
                color: markColor[x.type],
                name: x.type == "activity" ? props.Activities[x.id].name : x.name
              })
            }
          })
        }))
          .then(result => { 
            this.setState({ [props.routeId]: { ...this.state[props.routeId], [`geoLocatedRoute${props.day}`]: result, [`dayRoute${props.day}`]: dayRoute }})
            resolve(result)
          })
          .catch(item => {
            reject(item)
          })
      }
    })
  }

  calculateRoute(props) {
    const {googleRoute} = this.props
    const DirectionsService = new google.maps.DirectionsService()
    const bound = new google.maps.LatLngBounds()
    const marks = []
    const path = []
    const track = []
    let routeInfo = {}
    if (googleRoute.filter(s => s.daysCounter == props.day).length != 0) {

      routeInfo = { ...routeInfo, oneActivitie: false }
      const dayRoute = googleRoute.filter(s => s.daysCounter == props.day)
      this.addCoordsRoute(props, dayRoute).then(routeWithCoords => {
        const ruta = compact(routeWithCoords)
        if (ruta.length == 1) { //If the day only has one activity, we just put a mark on the position and bound to it

          marks.push(<Marker position={omit(ruta[0], ['color', 'mode', 'name'])} icon={`../../static/img/marks/${ruta[0].color}1.png`} />)
          routeInfo = { 
            ...routeInfo, 
            [`marks${props.day}`]: marks, 
            [`bound${props.day}`]: omit(ruta[0], ['color', 'mode', 'name']), 
            [`oneActivitie${props.day}`]: true 
          }
          this.setState({ 
            [props.routeId]: { 
              ...this.state[props.routeId], 
              ...routeInfo, 
              [`break${props.day}`]: false, 
              [`route${props.day}`]: ruta, 
              [`day${props.day}`]: "" 
            } 
          })
        } else if (!isEqual(this.state[props.routeId][`route${props.day}`], ruta)) { //We check if we already had that route calculated and if its the same, so we dont make unnecesary requests
          
          props.loadingMap(true)
          let cancelPromiseAll = false //No cancela el Promise.map, sino que las siguiente iteraciones no hagan trabajo innecesario
          Promise.all(ruta.map((x, u) => (
            new Promise((bigresolve, bigreject) => {
              if (u == ruta.length - 1) return bigresolve()
              const data = {
                origin: omit(ruta[u], ['color', 'mode', 'name']),
                destination: omit(ruta[u + 1], ['color', 'mode', 'name']),
                travelMode: travelModes[ruta[u + 1].mode],
              }
              if (u == 0) { //Here we put a mark in the first activitie of the day
                marks.push(<Marker position={omit(ruta[u], ['color', 'mode', 'name'])} icon={`../../static/img/marks/${ruta[u].color}1.png`} />)
                track.push(ruta[u].name)
                bound.extend(omit(ruta[u], ['color', 'mode', 'name']))
              }
              setTimeout(() => {
                if (this.state[props.routeId].lastDayHovered != props.day || cancelPromiseAll) {
                  return bigreject()
                }
                
                Ajax
                  .get(`/private/getmappath`)
                  .query(data)
                  .then((result) => {
                    if (result.body) {
                      return result.body
                    }
                    else {
                      return new Promise((miniresolve, minireject) => {
                        DirectionsService.route({
                          ...data,
                          transitOptions: x.transport ? {
                            modes: [x.transport],
                          } : {},
                          unitSystem: google.maps.UnitSystem.METRIC
                        }, (res, status) => {
                          if (status === google.maps.DirectionsStatus.OK) {
                            Ajax.post(`/private/addnewpath`)
                              .send(res)
                              .query(data)
                              .then(() => {
                                if (false)
                                  console.log("push successful")
                              })
                            miniresolve(res)
                          }
                          else {
                            cancelPromiseAll = true
                            minireject({ status, u })
                          }
                        })
                      })
                    }
                  })
                  .then(result => {
                    if (!track.includes(ruta[u + 1].name)) {
                      marks.push(<Marker position={omit(ruta[u + 1], ['color', 'mode', 'name'])} icon={`../../static/img/marks/${ruta[u + 1].color}${u + 2}.png`} />)
                      track.push(ruta[u + 1].name)
                    }
                    path[u] = (<DirectionsRenderer directions={result} options={{ suppressMarkers: true, preserveViewport: true }} />)
                    bound.extend(omit(ruta[u + 1], ['color', 'mode', 'name']))
                    routeInfo = { ...routeInfo, [`day${props.day}`]: path, [`marks${props.day}`]: marks, [`bound${props.day}`]: bound }
                    bigresolve()
                  })
                  .catch(error => {
                    cancelPromiseAll = true
                    bigreject(error)
                  })
              }, (23.8 * ruta.length * u) + 100)
            })
          ))).then(() => {
            props.loadingMap(false)
            this.setState({ [props.routeId]: { ...this.state[props.routeId], ...routeInfo, [`break${props.day}`]: false, [`route${props.day}`]: ruta } })
          }).catch((d) => {
            if (d) {
              console.error(`error fetching directions ${d.status}`)
              props.loadingMap(false)
              this.setState({ [props.routeId]: { ...this.state[props.routeId], [`break${props.day}`]: true, errormsg: getErrorMsg(d.status, ruta, d.u) } })
            }
          })
        } else this.setState({ [props.routeId]: { ...this.state[props.routeId], [`break${props.day}`]: false } })

      }).catch(item => {
        this.setState({ 
          [props.routeId]: { 
            ...this.state[props.routeId], 
            ...routeInfo, 
            [`break${props.day}`]: true, 
            [`needLegend${props.day}`]: false, 
            errormsg: <span>{getTextWithTokens(`No se pudo obtener automaticamente la direccion de $$, introducela `, [item.name])}{item.isActivity ? <a href={`/private/activity/${encodeURIComponent(item.id)}?`}>{getText("address_link")}</a> : ""}</span> 
          } 
        })
      })
    }
  }

  render() {
    const map = <GoogleMap
      ref={(ref) => { this.map = ref }}
      defaultZoom={5}
      defaultCenter={new google.maps.LatLng(40.463667, -3.74922)}
    >
      {!this.state[this.props.routeId][`break${this.props.day}`] && this.state[this.props.routeId][`day${this.props.day}`] && this.state[this.props.routeId][`day${this.props.day}`]}
      {!this.state[this.props.routeId][`break${this.props.day}`] && this.state[this.props.routeId][`marks${this.props.day}`] && this.state[this.props.routeId][`marks${this.props.day}`]}
    </GoogleMap>
    if (this.state[this.props.routeId][`bound${this.props.day}`] && !this.state[this.props.routeId][`break${this.props.day}`]) {
      if (this.map && this.state[this.props.routeId][`oneActivitie${this.props.day}`]
        && this.state[this.props.routeId][`bound${this.props.day}`]
        && isNumber(this.state[this.props.routeId][`bound${this.props.day}`].lat)
        && isNumber(this.state[this.props.routeId][`bound${this.props.day}`].lng)) this.map.panTo(this.state[this.props.routeId][`bound${this.props.day}`])
      else if (this.map) {
        this.map.fitBounds(this.state[this.props.routeId][`bound${this.props.day}`])
        this.map.panToBounds(this.state[this.props.routeId][`bound${this.props.day}`])
      }
    }
    return map
  }
}
export default withScriptjs(withGoogleMap(Map))